import { useCallback } from 'react';
import { Link } from 'react-router-dom';
import { getPADAC010ExistsMemberCert } from '../../../services/Api';
import useKcpCert, { toKcpCertFormData } from '../../../shared/hooks/useKcpCert';

const PADAA010 = ({ updateUserData, onNext }) => {
    const handleCertComplete = useCallback(
        (result) => {
            if (result.status !== 'SUCCESS') {
                window.alert(result.resMsg ? `본인인증에 실패했습니다.\n${result.resMsg}` : '본인인증에 실패했습니다.');
                return;
            }

            getPADAC010ExistsMemberCert(result.ordrIdxx)
                .then(({ data }) => {
                    if (data === 'exist') {
                        window.alert(
                            '이미 가입하신 계정이 존재합니다.\n가입하신 계정의 정보 확인은 [아이디/비밀번호 찾기]를 이용해 주세요.',
                        );
                    } else if (data === 'sleep') {
                        window.alert(
                            '등록된 휴면 계정이 있습니다.\n활성 계정으로 전환은, admin@dentaljob.co.kr 또는 080-801-1580으로 문의 부탁드립니다.',
                        );
                    } else if (data === 'non-exist') {
                        // Tên, ngày sinh, SĐT hiển thị chỉ đọc ở bước 3 (PADAC010)
                        updateUserData(toKcpCertFormData(result));
                        onNext();
                    }
                })
                .catch((error) => {
                    console.log(error);
                    // Backend trả NAErrorCode.message dạng chuỗi; chỉ các message tiếng Hàn là thông báo cho người dùng
                    const message = error?.response?.data;
                    window.alert(
                        typeof message === 'string' && /[가-힣]/.test(message)
                            ? message
                            : '가입여부를 확인할 수 없습니다.\n잠시 후 다시 시도해 주세요.',
                    );
                });
        },
        [updateUserData, onNext],
    );

    const { start: startKcpCert, loading: certLoading } = useKcpCert({
        popupOnly: true,
        onComplete: handleCertComplete,
    });

    return (
        <div className="register-container">
            <div id="register-check" className="content-wrap">
                <h1>회원가입여부 확인 안내</h1>
                <ul className="notes">
                    <li className="dot">휴대폰 본인인증을 통해 회원가입 여부를 확인합니다.</li>
                    <li className="dot">
                        회원이 되시면 하나의 통합된 회원 ID와 비밀번호로 각 웹사이트의 다양한 서비스 및 혜택을 이용하실
                        수 있습니다.
                    </li>
                    <li className="dot">
                        입력하신 정보는 별도 저장되지 않으며, 회원가입 여부 확인 용도로만 사용됩니다.
                    </li>
                </ul>
                <div className="register-form" id="mmbrs">
                    <div className="button-group">
                        <Link className="button button-blue" onClick={certLoading ? undefined : startKcpCert}>
                            {certLoading ? '인증 진행 중...' : '휴대폰 본인인증으로 가입여부 확인'}
                        </Link>
                    </div>
                </div>
                <div className="panel-body thumlogo">
                    <a href="http://www.dentaljob.co.kr" target="_blank" rel="noreferrer">
                        <img src="./images/PADAA010/dentailjob-logo.png" alt="dentaljob" />
                    </a>
                    <a href="http://www.dentalvitamin.com" target="_blank" rel="noreferrer">
                        <img src="./images/PADAA010/dentalvitamin-logo.png" alt="dentalvitamin" />
                    </a>
                    <a href="http://www.dentalseminar.co.kr" target="_blank" rel="noreferrer">
                        <img src="./images/PADAA010/dentalseminar-logo.png" alt="dentalseminar" />
                    </a>
                    <a href="http://www.dvmall.co.kr" target="_blank" rel="noreferrer">
                        <img src="./images/PADAA010/dvmall-logo.png" alt="dvmall" />
                    </a>
                </div>
            </div>
        </div>
    );
};

export default PADAA010;
